module.exports = __webpack_public_path__ + "static/media/hip2.61b57184.png";


//////////////////
// WEBPACK FOOTER
// ./src/hip2.png
// module id = 32
// module chunks = 0